import { useQuery } from "react-query";
import { getStudentDebtNotifications } from "../services/finance/studentDebtNotification";
import { PagedRequestType } from "../types/PagedResults";
import { Key_studentDebtNotifications } from "../utils/constants";

export const useGetStudentDebtNotificationsQuery  = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_studentDebtNotifications, JSON.stringify(data)],
    () => getStudentDebtNotifications(data), 
    options?{...options}:{}
  );